import { BASE_URL_API } from "constants/base-url-api";
import { getCookie } from "utils/functions-cookie";


export type CancellationPolicy = {
  end_date: string;
  start_date: string;
  value: AttributesValues;
};

type AttributesValues = {
  currency: string;
  value: number;
}

export type Reservation = {
  id: string;
  broker_reservation_id: number;
  broker_service_id: number;
  broker_selling_price: number;
  checkin_date: string;
  checkout_date: string;
  voucher_url: string;
  user_id: string;
  status: string;
  has_additional_payment: boolean;
  cancellation_policies: CancellationPolicy[];
};

export type Root = Reservation[] & {
  detail?: string;
};

export const fetchReservation = async () => {
  const authToken = getCookie("auth_token");

  if (!authToken) {
    throw new Error("Você não está autenticado.");
  }
  const response = await fetch(`${BASE_URL_API}/bookings`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
    },
  });

  if (response.status !== 200) {
    throw new Error("Erro ao carregar reservas.");
  }

  return response.json() as Promise<Root>;
};
